module.exports = __webpack_public_path__ + "64fc0495264fbd04ade2112d34c7a4e5.pdf";